const FORMATION_PLANS = ['starter', 'pro', 'premium'];
const REGISTERED_AGENT_PLANS = ['ra_starter', 'ra_pro'];

const findFormationPlanInCartItems = (cartItems) =>
  FORMATION_PLANS.find((plan) =>
    cartItems.some((item) => item.hasFormation && item.serviceName.includes(plan))
  );

const findRegisteredAgentPlanInCartItems = (cartItems) =>
  REGISTERED_AGENT_PLANS.find((plan) => cartItems.some((item) => item.serviceName.includes(plan)));

/**
 * Finds the appropriate plan in the cart items based on the plan type.
 *
 * @param {Array} cartItems - The list of cart items.
 * @param {'any' | 'formation'} [planType='formation'] - The type of plan to find.
 * @returns {string | null} - The found plan or null.
 */
export default function planPurchase(cartItems, planType = 'formation') {
  const formationPlan = findFormationPlanInCartItems(cartItems);
  if (planType === 'formation') {
    return formationPlan ?? null;
  }

  const registeredAgentPlan = findRegisteredAgentPlanInCartItems(cartItems);
  return formationPlan ?? registeredAgentPlan ?? null;
}
